import DashboardCard from "../../../ui/DashboardCard/DashboardCard";
import type { TeenDashboardGuardianItemResponse } from "../../../../types/teenDashboardTypes";
import { guardianStatusPillClassName } from "../shared/dashboardDisplay";

type TeenGuardiansBoxProps = {
  guardians: TeenDashboardGuardianItemResponse[];
  loading: boolean;
};

const TeenGuardiansBox = ({ guardians, loading }: TeenGuardiansBoxProps) => {
  return (
    <DashboardCard to="/teen/guardians" title="My Guardians" subtitle="View and Request Guardians.">
      <div className="space-y-3">
        {loading ? (
          <p className="text-sm text-myteengig-text-muted">Loading guardians...</p>
        ) : guardians.length === 0 ? (
          <p className="text-sm text-myteengig-text-muted">No guardians linked yet.</p>
        ) : (
          guardians.map((guardian) => (
            <div
              key={`${guardian.teenUserId ?? "teen"}-${guardian.guardianUserId ?? "guardian"}-${guardian.updatedAt}`}
              className="min-w-0 rounded-lg border border-myteengig-border bg-myteengig-background p-3"
            >
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <p className="min-w-0 font-semibold text-myteengig-text-primary">
                  {[guardian.guardianFirstName, guardian.guardianLastName].filter(Boolean).join(" ") || "Guardian"}
                </p>
                <span
                  className={`rounded-full border px-2 py-1 text-xs font-semibold ${guardianStatusPillClassName[guardian.status]}`}
                >
                  {guardian.status}
                </span>
              </div>
              <p className="mt-1 min-w-0 break-words text-sm text-myteengig-text-muted [overflow-wrap:anywhere]">
                {guardian.guardianEmail ?? "No email provided"}
              </p>
            </div>
          ))
        )}
      </div>
    </DashboardCard>
  );
};

export default TeenGuardiansBox;
